module.exports = __webpack_public_path__ + "static/WatchOut-704cc41382144a27a4aeb13799035d54.png";